import { createContext, useContext, useState, type ReactNode } from "react";

import {
  NoViewsLeftModal,
  SearchProfileLimitModal,
} from "@/components/gating/UpsellModals";

/** Límites de plan que el backend rechaza y el front explica con un modal. */
export type UpsellKind = "no-views" | "profile-limit";

/**
 * Estos dos muros no los levanta una pantalla sino el `onError` de una mutation,
 * que no puede renderizar. El modal se monta una sola vez aquí y las mutations
 * solo piden abrirlo.
 */
const UpsellContext = createContext<(kind: UpsellKind) => void>(() => {});

export function useUpsell() {
  return useContext(UpsellContext);
}

export function UpsellProvider({ children }: { children: ReactNode }) {
  const [kind, setKind] = useState<UpsellKind | null>(null);

  return (
    <UpsellContext.Provider value={setKind}>
      {children}
      <NoViewsLeftModal
        open={kind === "no-views"}
        onOpenChange={(open) => !open && setKind(null)}
      />
      <SearchProfileLimitModal
        open={kind === "profile-limit"}
        onOpenChange={(open) => !open && setKind(null)}
      />
    </UpsellContext.Provider>
  );
}
